import axios from "axios";
import { parseISO } from "date-fns";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { FartherAccountId, InstitutionId, PhysicalAccountId, TransferId, } from "../../Types";
import ValidationError from "../../ZodError";
import { accountTypes } from "./Types";
export const TifId = z.custom((val) => typeof val === "string");
const TransferAcatsCustodianDetails = z.object({
    tifId: TifId,
    acatsControlNumber: z.string().nullable(),
    status: z.string(), //An Enum with many possibilities not yet provided or needed in the UI.
});
export const transferTypes = [
    "UNDEFINED",
    "FAIL_REVERSAL_BROKER_TO_BROKER_ONLY",
    "FULL_TRANSFER",
    "MUTUAL_FUND_CLEANUP",
    "PARTIAL_TRANSFER_DELIVERER",
    "PARTIAL_TRANSFER_RECEIVER",
    "POSITION_TRANSFER_FUND_FIRM_TO_MUTUAL_FUND_COMPANY_ONLY",
    "RECLAIM",
    "RESIDUAL_CREDIT",
];
export const directionOptions = ["LEAVING", "JOINING"];
export const statusOptions = [
    "COMPLETE",
    "REJECTED",
    "ERROR",
    "PENDING_INITIATION",
    "REQUESTED_PENDING_SIGNATURE",
    "REQUESTED_PENDING_PROCESSING",
];
const TransferAcats = z.object({
    custodianDetails: TransferAcatsCustodianDetails.nullable(),
    accountHolderName: z.string(),
    accountNumber: z.string(),
    accountType: z.enum(accountTypes),
    createTime: z.string(),
    direction: z.enum(directionOptions),
    institutionId: InstitutionId,
    modifyTime: z.string(),
    physicalAccountId: PhysicalAccountId,
    virtualAccountId: FartherAccountId,
    status: z.enum(statusOptions),
    transferId: TransferId,
    transferType: z.enum(transferTypes),
});
const GetTransferAcatsResponse = z.object({
    transfers: TransferAcats.array(),
});
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/transfer/v1/transfers/acats"
    : "https://middleware.uat.farther.com/transfer/v1/transfers/acats";
export default async function getAcatsTransfers(config) {
    const { data } = await axios.get(url(), {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = GetTransferAcatsResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data.transfers.map(({ createTime, modifyTime, ...transfer }) => ({
            ...transfer,
            createTime: parseISO(createTime),
            modifyTime: parseISO(modifyTime),
        }));
    }
    else {
        const errorMessage = `${getAcatsTransfers.name} Could not parse.`;
        errorLog(getAcatsTransfers.name, `Could not parse, ${decoded.error.message} ${JSON.stringify(decoded.error.issues)}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAcatsTransfers.js.map